<template>
  <div class="container">
    <div class="people" @click="share">
    <div v-bind:class="{'active' : isAcTive}">
      <img src="../assets/images/infosImages/arrow.png" alt>
    </div>
    <!-- 模态 -->
    <div class="modial" v-show="isShow">
      <div class="modial_in">
        <p class="title">我是谜app打开方式</p>
        <p class="browser">1. 点击右上角[...]</p>
        <p class="direct">2. 选择[在浏览器中打开]</p>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "People",
  data() {
    return {
      isAcTive: true, //or false
      // this.isAcTive=true;  若初始状态是false (data中的值) 则在页面初始化是动画进行
      isShow: false
    };
  },
  created() {
    document.getElementsByTagName("title")[0].innerText = "烧脑推理就去我是谜";
    this.onShare();
  },
  methods: {
    share() {
      var ua = navigator.userAgent.toLowerCase();
      if (
        ua.match(/MicroMessenger/i) == "micromessenger" ||
        ua.match(/QQ/i) == "qq"
      ) {
        this.isShow = true;
      } else {
        // window.location.href = "mvoicerwsm://";//ios
        window.location.href = "mvoicerwsm://openapp";//安卓
        //记录唤醒时间
        var openTime = +new Date();
        window.setTimeout(function() {
          if (+new Date() - openTime > 1000) {
            window.location.href = "https://share.mvoicer.com/#/open";
          }
        }, 1500);
      }
    },
    onShare() {
      // 传入后台签名URL，域名+当前分享页面路径
      let _WXurl = window.location.origin + window.location.pathname;
      // 定义分享链接,使用encodeURIComponent对传入参数编码，防止在iOS中传入参数编码问题
      // 此处示例传递单个参数
      console.log(_WXurl);
      let _shareLink =
        "/#?" +
        encodeURIComponent("key") +
        "=" +
        encodeURIComponent("value");
      let params = {
        url: _WXurl
      };
      // 网络请求部分
      let url = window.location.href;
      console.log(url);
      axios({
        url:
          "https://woshimimall.mvoicer.com/woshimi_app/system/wechat/officialAccounts/signature",
        method: "post",
        dataType: "json",
        data: { url: url }
      }).then(res => {
        console.log(res);
        this.signature = res.data.data.signature;
        this.appId=res.data.data.appId;
        this.timestamp=res.data.data.timestamp;
        this.nonceStr=res.data.data.nonceStr
        console.log(this.signature);
        console.log(this.appId);
        console.log(this.timestamp);
        console.log(this.nonceStr)
        if (res.data.code === 200) {
          // 请求接口成功后，
          // 配置config
          wx.config({
            // 开启调试模式时,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            debug: false,
            // 后台返回之前获取的appId
            appId: this.appId,
            // 必填，生成签名的时间戳
            timestamp: this.timestamp,
            // 必填，生成签名的随机串
            nonceStr: this.nonceStr,
            // 必填，签名，见附录1
            signature: this.signature,
            jsApiList: [
              "checkJsApi",
              "onMenuShareTimeline",
              "onMenuShareAppMessage",
              "hideMenuItems"
            ]
          });
          // 微信检查接口列表
          wx.checkJsApi({
            jsApiList: [
              "onMenuShareTimeline",
              "onMenuShareAppMessage",
              "hideMenuItems"
            ], // 需要检测的JS接口列表
            success: function(res) {
              console.log(res);
            }
          });
          // 页面加载完成后用户就有可能调用微信的分享，所以当页面ready 完后就加载
          wx.ready(function() {
            // 分享到朋友圈
            wx.onMenuShareTimeline({
              // 分享标题
              title: "烧脑推理就去我是谜",
              // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              link: url,
              // 分享图标
              imgUrl: "https://woshimiimage.mvoicer.com/image/item/showImg/1547643411518",
              // 用户确认分享后执行的回调函数
              success: function() {
                console.log(url)
                console.log("分享回调函数");
                console.log("shareLink= " +url);
                // alert('分享回成功调函数');
              },
              // 用户取消分享后执行的回调函数
              cancel: function() {
                console.log("取消分享回调函数");
                // alert('取消分享回调函数');
              }
            });
            // 分享好友
            wx.onMenuShareAppMessage({
              // 分享标题
              title: "烧脑推理就去我是谜",
              // 分享描述
              desc: "张建的我是谜个人主页",
              // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              link: url,
              // 分享图标
              imgUrl: "https://woshimiimage.mvoicer.com/image/item/showImg/1547643411518",
              // 用户确认分享后执行的回调函数
              success: function() {
                console.log("分享好友回调函数");
                console.log("shareLink= " + url);
                // alert('分享回好友调函数');
              },
              // 用户取消分享后执行的回调函数
              cancel: function() {
                console.log("取消分享好友调函数");
                
              }
            });
            // 分享多个地址时，可统一传入参数，如 wx.onMenuShareAppMessage(shareData)
          });
          // 微信预加载失败回调
          wx.error(function(res) {
            console.log(res);
            
          });
        }
      });
    }
  }
};
</script>
<style scoped>
.people {
  display: block;
  background: url("../assets/images/infosImages/bg1.png") no-repeat left top;
  position: relative;
  background-size: cover;
  width: 100%;
  height: 33.6rem;
  position: relative;
}
.people .active {
  position: absolute;
  left: 8.625rem;
  bottom: 7.5rem;
  width: 2.225rem;
  height: 1.55rem;
}
.people .active img {
  width: 100%;
  height: 100%;
}
@keyframes active {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(0.75rem);
  }
  100% {
    transform: translateY(0);
  }
}
.active {
  animation: active 1s 1s infinite linear;
}
/* 模态 */
.modial {
  position: fixed;
  width: 100%;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.1);
  height: 30.15rem;
  background-size: cover;
}
.modial .modial_in {
  padding-left: 0.5rem;
  text-align: left;
  position: absolute;
  background: rgb(255, 255, 255);
  width: 8.75rem;
  height: 5rem;
  left: 50%;
  bottom: 50%;
  transform: translateX(-50%);
  border-radius: 0.5rem;
}
.modial .modial_in p {
  font-size: 0.5rem;
  margin-top: 0.5rem;
}
.modial .modial_in .title {
  font-size: 0.75rem;
  font-weight: bold;
}
</style>





// WEBPACK FOOTER //
// src/components/people.vue